<template>
  <button
    :id="action.value"
    :ref="action.value"
    class="action-key"
    :aria-describedby="action.value"
    :data-entity="`producer-editor-${action.value}`"
    :data-test="`panel-editor-${hotkey.toLowerCase() || 'unmapped'}`"
    @click="handleClickAction($event, action)"
  >
    <div class="action-key-header" style="display:flex; flex-direction: column;" :id="action.value">
      <strong class="action-key-letter">{{hotkey}}</strong>
      <strong class="action-key-name">{{action.display}}</strong>
    </div>

    <transition-group>
      <span
        v-for="(val, i) in filteredRipples"
        :key="'ripple' + i"
        class="ripple"
        :ref="'ripple-' + i"
        :style="{'top': val.y + 'px', 'left': val.x + 'px'}"
        @animationend="rippleEnd(i)"
      />
    </transition-group>
  </button>
</template>

<script>
export default {
  props: {
    action: {
      type: Object,
      required: true,
    },

    production_context: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },

  mixins: [],

  inject: {
    onWidgetAction: {
      default: () => () => {},
    },
  },

  data() {
    return {
      ripples: [],
    };
  },

  mounted() {
    if (this.hotkey) {
      window.addEventListener('keypress', this.handleKeyPress);
    }
  },

  unmounted() {
    window.removeEventListener('keypress', this.handleKeyPress);
  },

  computed: {
    filteredRipples() {
      return this.ripples.filter((r) => r.show);
    },

    hotkey() {
      return this.action.hotkey || '';
    },
  },

  methods: {
    rippleEnd(i) {
      this.ripples[i].show = false;
    },

    handleClickAction(e, action) {
      const el = this.$refs[action.value];
      if (!el) {
        console.warn('Ignoring handleClickAction for button that no longer exists:', action.value, this.$refs);
        return;
      }

      const pos = el.getBoundingClientRect();

      this.ripples.push({
        x: e.clientX - pos.left,
        y: e.clientY - pos.top,
        show: true,
      });

      switch (action.type) {
        case 'frame-trigger': {
          this.$emit('trigger', action.value);
          break;
        }

        case 'timer widget': {
          this.onWidgetAction(action);
          break;
        }

        default: {
          if (this.production_context.live) {
            this.$store.dispatch('sendAction', action);
          }

          if (this.production_context.preview) {
            this.$store.dispatch('sendPreviewAction', action);
          }
        }
      }
    },

    handleKeyPress(e) {
      if (
        this.hotkey.toLowerCase() === e.key.toLowerCase()
        && e.target.tagName !== 'INPUT'
      ) {
        this.handleClickAction(e, this.action);
      }
    },
  },
};
</script>
